import React from 'react';
import logo from './logo.svg';
import './App.css';
import './styles/styles.scss';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Route, NavLink, Switch, Redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import Password from './components/Password';
import Discount from './components/Discount';

function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route exact path="/" component={(props) => { return <Redirect to={`/password`} /> }} />
          <Route exact path="/password" component={(props) => <Password routeProps={props} />} />
          <Route exact path="/discount" component={(props) => <Discount routeProps={props} />} />
        </Switch>
      </div>
      <ToastContainer autoClose={2000} position={toast.POSITION.TOP_RIGHT} />
    </Router>
  );
}

export default App;
